export default __webpack_public_path__ + "static/media/tuzhi-logo.7eb5649c.svg";